import * as React from 'react';
import {
  Component,
  Plugins,
  Expressions,
  TypeImplementation,
  matchExpression,
} from '@packages/systems/wfdl';
import {
  updateExpressionAction,
  ExpressionEditor,
} from '@packages/systems/ExpressionEditor-utils';
import {qualify} from '@packages/systems/wfdl-Qualified';
import {instantiateExpressionWithUniqueIds} from '@packages/utilities/platform-instantiateExpressionWithUniqueIds';
import {generateGuid} from '@packages/utilities/guid';
import {getSecond} from '@packages/utilities/Pair';

import {
  TList,
  EElement,
  EText,
  ERecord,
  EList,
  TElement,
  EEnum,
} from '@packages/systems/wfdl-ast';

import {stripAll} from '@packages/utilities/contextual-expression';

export const AddChildren = TypeImplementation.Alias({
  type: TList(TElement),
  render: ({expr, dispatch}) => {
    const addChild = () => {
      const hTag = String(Math.ceil(Math.random() * 5));

      // Create a new child with a unique id and append that to the list of
      // existing children
      const newChild = getSecond(
        instantiateExpressionWithUniqueIds(
          EElement({
            id: 'tempIdToBeReplaced',
            type: qualify(Plugins.name('Basic'), Component.name('Heading')),
            data: ERecord({
              tag: EEnum(`h${hTag}`),
              children: EList([
                EElement({
                  id: 'tempIdToBeReplaced',
                  type: qualify(
                    Plugins.name('Basic'),
                    Component.name('String')
                  ),
                  data: EText(`Heading ${hTag}`),
                }),
              ]),
            }),
          })
        )(generateGuid())
      );
      // `stripAll` is super expensive here, tracking for alternate solutions:
      // https://webflow.atlassian.net/browse/LOGIC-3738
      const oldChildren = Expressions.getList(stripAll(expr)) || [];
      const newChildList = EList([...oldChildren, newChild]);
      dispatch(updateExpressionAction(newChildList));
    };
    const isListOfElements = matchExpression({
      List: (items) => {
        const firstItem = items.length > 0 ? items[0] : null;
        const firstItemIsElement = firstItem
          ? matchExpression({Element: (_) => true, _: (_) => false})(firstItem)
          : false;
        return firstItemIsElement;
      },
      _: (_) => false,
    })(stripAll(expr));
    if (isListOfElements) {
      return (
        <button
          style={{backgroundColor: 'grey', color: 'red', fontSize: '32px'}}
          onClick={addChild}
        >
          Click for children
        </button>
      );
    } else {
      return <ExpressionEditor expression={expr} dispatch={dispatch} />;
    }
  },
});
